import { render } from "./LogoSection.vue?vue&type=template&id=b1829cdc&scoped=true"
import script from "./LogoSection.vue?vue&type=script&lang=js"
export * from "./LogoSection.vue?vue&type=script&lang=js"

import "./LogoSection.vue?vue&type=style&index=0&id=b1829cdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1829cdc"]])

export default __exports__